let url = $(location).attr('href').split('/').splice(0, 5).join('/');
let segments = url.split('/');
let lang = segments[3];
let two_segment = segments[4];
if ('' === lang) {
	lang = 'ro';
}

let loader = `
<div class="loader_centered">
	<div class="loader_body">
		<div class="loader_dot"></div>
		<div class="loader_dot"></div>
		<div class="loader_dot"></div>
	</div>
</div>
`;

window.addEventListener('load', function () {
	setTimeout(function () {
		document.getElementById('loader').classList.add('loader_hidden');
		setTimeout(function () {
			document.getElementById('loader').style.display = 'none';
			document.querySelector('.wrapper').style.display = 'block';
		}, 500);
	}, 500);
});

$(document).ready(function () {
	//! Favorites
	$(document).on('click', '.add_to_favorite', function (event) {
		event.preventDefault();
		const _self = $(this);
		const box = _self.closest('.favorite__box');
		const id = box.data('id');
		$.post(
			'/' + lang + '/ajax/add_to_favorite',
			{ id: id },
			function (response) {
				let data = JSON.parse(response);
				$('[data-id="' + id + '"]').each(function () {
					if (data.action === 'add') {
						$(this).addClass('_liked');
						$(this).addClass('_active');
					} else {
						$(this).removeClass('_liked');
						$(this).removeClass('_active');
						if ($(this).hasClass('delete_favorite')) {
							window.location.reload();
						}
					}
				});
				$('.favorite_count').text(data.count);
			},
		);
	});
	$(document).on('click', '.clear_all_favorites', function (event) {
		event.preventDefault();
		$.get('/' + lang + '/ajax/clear_all_favorites', function (response) {
			let data = JSON.parse(response);
			window.location.reload();
		});
	});
	$('.cabinet__checkbox').on('change', function () {
		let value = $(this).is(':checked') ? 1 : 0;
		$.ajax({
			url: '/ajax/change_price_a', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { value: value },
			success: function (data) {
				console.log('data: ', data);
				if (data.status == 'ok') {
					// window.location.reload();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Tabs
	const tabs = document.querySelectorAll('.tab__item');
	tabs.forEach(tab => {
		tab.addEventListener('click', function (event) {
			const tabType = tab.getAttribute('data-tab');
			const url = new URL(window.location.href);

			if (tab.classList.contains('_active')) {
				url.searchParams.set('tab', tabType);
			} else {
				url.searchParams.delete('tab');
			}

			if (tabType === 'favorites') {
				$('.clear_all_favorites').show();
			} else {
				$('.clear_all_favorites').hide();
			}

			window.history.pushState({}, '', url);
		});
	});

	//! Catalog
	if ($('.catalog__container, .list__container').length) {
		create_filter_mod();

		$(document).on(
			'click',
			'.pagging__arrow, .pagging__item',
			function (event) {
				event.preventDefault();
				let page = $(this).data('page');
				console.log('page: ', page);
				if (page == '...') return;
				$('input[name=page]').val(page);
				reload_flt();
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			},
		);

		$(document).on('click', '.select__option', function (event) {
			event.preventDefault();
			let sort = $(this).data('value');
			$('input[name=page]').val(1);
			$('input[name=sort]').val(sort);
			reload_flt();
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});

		$(document).on('click', '.reset__filters', function (event) {
			event.preventDefault();
			let url = $(this).data('url');
			window.location.href = url;
		});

		$(document).on('change', '.checkbox__filter', function (event) {
			$('input[name=page]').val(1);
			create_filter_mod();
			reload_flt();
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});
		$(document).on('change', '.range__filter', function (event) {
			$('input[name=page]').val(1);
			reload_flt();
		});

		$(document).on('click', '.mod__remove', function (e) {
			e.preventDefault();
			const filterItem = $(this).closest('.mods-filter-catalog__item');
			const valueText = filterItem
				.find('.mods-filter-catalog__value')
				.text()
				.split(' - ')[1];
			const checkbox = $('.checkbox__filter[data-value="' + valueText + '"]');
			filterItem.remove();
			checkbox.prop('checked', false);
			reload_flt();
		});

		function reload_flt() {
			let ajax__list = $('.ajax__list');
			let ajax__count = $('.ajax__count');
			let ajax__filters = $('.ajax__filters');
			// let ajax__footer = $('.ajax__footer a');
			let ajax__table = $('.ajax__table').data('table');
			let formData = $('form[name=catalog]').serialize();
			formData = formData.replace(/[^&]+=\.?(?:&|$)/g, '');

			console.log('formData: ', formData);

			$('.catalog__body').html(loader);

			let searchParams = new URLSearchParams(window.location.search);
			let filteredParams = new URLSearchParams();
			for (let [key, value] of searchParams.entries()) {
				if (key.startsWith('search')) {
					filteredParams.append(key, value);
				}
			}
			let parameters = filteredParams.toString();
			if (formData) {
				if (parameters) {
					parameters += '&' + formData;
				} else {
					parameters = formData;
				}
			}
			if (parameters !== '') sign = '?';
			else sign = '';

			console.log('parameters: ', parameters);

			history.pushState(
				{},
				null,
				decodeURI(window.location.pathname + sign + parameters),
			);

			ajax__list.css({
				opacity: 0.6,
			});

			let url =
				window.location.pathname.replace(ajax__table, 'ajax_' + ajax__table) +
				'?' +
				parameters;

			$.get(url, function (response) {
				let data = JSON.parse(response);
				ajax__list.replaceWith(data.view);
				ajax__filters.replaceWith(data.filters);
				// ajax__footer.replaceWith(data.footer);
				ajax__count.html(data.count);
				$('.total__count').html(data.total);
				ajax__list.css({
					opacity: 1,
				});
				attachQuantityButtonListeners();
				attachFiltersSpollerListeners();
				attachPopupListeners();
				return false;
			});
		}

		function create_filter_mod() {
			const filterContainer = $('.filter__mods');
			filterContainer.empty();
			$('.checkbox__filter:checked').each(function () {
				const title = $(this).data('title');
				const value = $(this).data('value');
				const filterItem = $(`
							<span class="mods-filter-catalog__item">
									<span class="mods-filter-catalog__value">${title} - ${value}</span>
									<a href="" class="mods-filter-catalog__delete mod__remove">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path d="M15.8333 5.34199L14.6583 4.16699L10 8.82533L5.34167 4.16699L4.16667 5.34199L8.82501 10.0003L4.16667 14.6587L5.34167 15.8337L10 11.1753L14.6583 15.8337L15.8333 14.6587L11.175 10.0003L15.8333 5.34199Z" fill="white" />
											</svg>
									</a>
							</span>
					`);
				filterContainer.append(filterItem);
			});
		}

		function attachQuantityButtonListeners() {
			let quantityContainers = document.querySelectorAll('.quantity');
			quantityContainers.forEach(container => {
				let newContainer = container.cloneNode(true);
				container.parentNode.replaceChild(newContainer, container);
			});
			let quantityButtons = document.querySelectorAll('.quantity__button');
			if (quantityButtons.length > 0) {
				for (let index = 0; index < quantityButtons.length; index++) {
					const quantityButton = quantityButtons[index];
					quantityButton.addEventListener('click', function (e) {
						let value = parseInt(
							quantityButton.closest('.quantity').querySelector('input').value,
						);
						if (quantityButton.classList.contains('quantity__button_plus')) {
							value++;
						} else {
							value = value - 1;
							if (value < 1) {
								value = 1;
							}
						}
						quantityButton.closest('.quantity').querySelector('input').value =
							value;
					});
				}
			}
		}

		function attachFiltersSpollerListeners() {
			let spollers = document.querySelectorAll('._spoller');
			let spollersGo = true;
			if (spollers.length > 0) {
				for (let index = 0; index < spollers.length; index++) {
					const spoller = spollers[index];
					spoller.addEventListener('click', function (e) {
						if (spollersGo) {
							spollersGo = false;
							if (
								spoller.classList.contains('_spoller-992') &&
								window.innerWidth > 992
							) {
								return false;
							}
							if (
								spoller.classList.contains('_spoller-768') &&
								window.innerWidth > 768
							) {
								return false;
							}
							if (spoller.closest('._spollers').classList.contains('_one')) {
								let curent_spollers = spoller
									.closest('._spollers')
									.querySelectorAll('._spoller');
								for (let i = 0; i < curent_spollers.length; i++) {
									let el = curent_spollers[i];
									if (el != spoller) {
										el.classList.remove('_active');
										_slideUp(el.nextElementSibling);
									}
								}
							}
							spoller.classList.toggle('_active');
							_slideToggle(spoller.nextElementSibling);

							setTimeout(function () {
								spollersGo = true;
							}, 500);
						}
					});
				}
			}
		}

		function attachPopupListeners() {
			let popup_link = document.querySelectorAll('._popup-link');
			let popups = document.querySelectorAll('.popup');
			for (let index = 0; index < popup_link.length; index++) {
				const el = popup_link[index];
				el.addEventListener('click', function (e) {
					if (unlock) {
						let item = el.getAttribute('href').replace('#', '');
						let video = el.getAttribute('data-video');
						popup_open(item, video);
					}
					e.preventDefault();
				});
			}
			for (let index = 0; index < popups.length; index++) {
				const popup = popups[index];
				popup.addEventListener('click', function (e) {
					if (!e.target.closest('.popup__body')) {
						popup_close(e.target.closest('.popup'));
					}
				});
			}
			let popup_close_icon = document.querySelectorAll(
				'.popup__close,._popup-close',
			);
			if (popup_close_icon) {
				for (let index = 0; index < popup_close_icon.length; index++) {
					const el = popup_close_icon[index];
					el.addEventListener('click', function () {
						popup_close(el.closest('.popup'));
					});
				}
			}
			document.addEventListener('keydown', function (e) {
				if (e.code === 'Escape') {
					popup_close();
				}
			});
		}
	}

	//! Search
	$('#search').on(
		'keyup',
		debounce(function () {
			searchProducts();
		}, 1200),
	);
	function searchProducts() {
		let element = document.getElementById('search');
		let searchQuery = element.value.trim();
		let currency = element.getAttribute('data-currency');
		let results = element.getAttribute('data-results');
		let all_results = element.getAttribute('data-all_results');
		let uri = element.getAttribute('data-uri');

		$('.search__categories').html(loader);
		$('.search__products').html(loader);

		if (searchQuery.length >= 3) {
			$.ajax({
				url: '/' + lang + '/input_search',
				method: 'POST',
				data: {
					lang: lang,
					searchQuery: searchQuery,
				},
				success: function (response) {
					let data = JSON.parse(response);

					let categoriesHTML = '';
					let productsHTML = '';

					if (data.products.length > 0) {
						categoriesHTML += `<a href="/${lang}/search?search=${searchQuery}" class="sidebar-result-search-header__item search_categories_item _tabs-item _active">
																	<span class="sidebar-result-search-header__value">${all_results}</span>
																	<span class="sidebar-result-search-header__count">${data.products.length}</span>
																</a>`;

						productsHTML += `<div class="result-search-header__block search_products_item _tabs-block _active">`;
						data.products.forEach(product => {
							// Image
							let firstImage =
								product.images.length > 0 ? product.images[0] : '';
							let imageHTML = '';
							if (firstImage) {
								let src = '';
								if (firstImage.startsWith('http')) {
									src = firstImage;
								} else {
									src = `/public/products/${firstImage}`;
								}
								imageHTML = `<picture>
																			<source srcset="${src}" type="image/webp">
																			<img src="${src}" alt="Image">
																	 </picture>`;
							}
							// Price
							let priceHTML = '';
							if (product.old_price && product.old_price > product.price) {
								priceHTML = `<span class="_now">${product.price} ${currency}</span>
																<span class="_old">${product.old_price} ${currency}</span>`;
							} else {
								priceHTML = `<span>${product.price} ${currency}</span>`;
							}
							// Text
							let textHTML = '';
							if (product.text) {
								textHTML = `<p class="product-result-search-header__text">${product.text}</p>`;
							}
							// List
							productsHTML += `<div class="result-search-header__product product-result-search-header">
																<a href="/${lang}/product/${product.uri}" class="product-result-search-header__image">
																	${imageHTML}
																</a>
																<div class="product-result-search-header__body">
																	<div class="product-result-search-header__info">
																		<a href="/${lang}/product/${product.uri}" class="product-result-search-header__name">${product.title}</a>
																		${textHTML}
																	</div>
																	<p class="product-result-search-header__price">
																		${priceHTML}
																	</p>
																</div>
															</div>`;
						});
						productsHTML += `</div>`;
					}

					if (data.categories.length > 0) {
						data.categories.forEach((category, index) => {
							let activeClass = index === 0 ? '' : '';

							categoriesHTML += `<a href="/${lang}/search?search=${searchQuery}&filters[categories][${
								category.id
							}][]=${encodeURIComponent(
								category.title,
							)}" class="sidebar-result-search-header__item search_categories_item _tabs-item ${activeClass}">
																	<span class="sidebar-result-search-header__value">${category.title}</span>
																	<span class="sidebar-result-search-header__count">${category.count}</span>
																</a>`;

							productsHTML += `<div class="result-search-header__block search_products_item _tabs-block ${activeClass}">`;
							if (category.products && category.products.length > 0) {
								category.products.forEach(product => {
									// Image
									let firstImage =
										product.images.length > 0 ? product.images[0] : '';
									let imageHTML = '';
									if (firstImage) {
										let src = '';
										if (firstImage.startsWith('http')) {
											src = firstImage;
										} else {
											src = `/public/products/${firstImage}`;
										}
										imageHTML = `<picture>
																			<source srcset="${src}" type="image/webp">
																			<img src="${src}" alt="Image">
																	 </picture>`;
									}
									// Price
									let priceHTML = '';
									if (product.old_price && product.old_price > product.price) {
										priceHTML = `<span class="_now">${product.price} ${currency}</span>
																<span class="_old">${product.old_price} ${currency}</span>`;
									} else {
										priceHTML = `<span>${product.price} ${currency}</span>`;
									}
									// Text
									let textHTML = '';
									if (product.text) {
										textHTML = `<p class="product-result-search-header__text">${product.text}</p>`;
									}
									// List
									productsHTML += `<div class="result-search-header__product product-result-search-header">
																<a href="/${lang}/product/${product.uri}" class="product-result-search-header__image">
																	${imageHTML}
																</a>
																<div class="product-result-search-header__body">
																	<div class="product-result-search-header__info">
																		<a href="/${lang}/product/${product.uri}" class="product-result-search-header__name">${product.title}</a>
																		${textHTML}
																	</div>
																	<p class="product-result-search-header__price">
																		${priceHTML}
																	</p>
																</div>
															</div>`;
								});
							}
							productsHTML += `</div>`;
						});
					}

					if (productsHTML === '') {
						productsHTML = `<p class="product-result-search-header__name" style="padding: 10px;">${results}</p>`;
					} else {
						$('.search-header__result').addClass('_category');
					}

					// Show results
					$('.search__categories').html(categoriesHTML);
					$('.search__products').html(productsHTML);

					// Add hover effect
					$('.search_categories_item').hover(function () {
						let index = $(this).index();
						$('.search_categories_item').removeClass('_active');
						$('.search_products_item').removeClass('_active');
						$(this).addClass('_active');
						$('.search_products_item').eq(index).addClass('_active');
					});
				},
				error: function (xhr, status, error) {
					console.error(error);
				},
			});
		}
	}
	function debounce(func, delay) {
		let timeoutId;

		return function () {
			const context = this;

			const args = arguments;

			clearTimeout(timeoutId);

			timeoutId = setTimeout(() => {
				func.apply(context, args);
			}, delay);
		};
	}

	//! Cart
	function header_cart() {
		$.ajax({
			url: '/' + lang + '/header_cart', // путь к обработчику

			type: 'POST', // метод отправки,

			dataType: 'html',

			data: { cart: 1 },

			success: function (data) {
				$('.header__cart').html(data);

				let quantityContainers = document.querySelectorAll('.quantity');

				quantityContainers.forEach(container => {
					let newContainer = container.cloneNode(true);

					container.parentNode.replaceChild(newContainer, container);
				});

				let quantityButtons = document.querySelectorAll('.quantity__button');

				if (quantityButtons.length > 0) {
					for (let index = 0; index < quantityButtons.length; index++) {
						const quantityButton = quantityButtons[index];

						quantityButton.addEventListener('click', function (e) {
							let value = parseInt(
								quantityButton.closest('.quantity').querySelector('input')
									.value,
							);

							if (quantityButton.classList.contains('quantity__button_plus')) {
								value++;
							} else {
								value = value - 1;

								if (value < 1) {
									value = 1;
								}
							}

							quantityButton.closest('.quantity').querySelector('input').value =
								value;
						});
					}
				}
			},

			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
	// Add to cart
	$('body').on('click', '.add_to_cart', function (e) {
		e.preventDefault();

		const _self = $(this);

		let type = _self.data('type');

		let product = _self.closest('.product__box');

		let id = product.data('id');

		let qty = product.find('.quantity__input input').val();

		if (type === 'checkbox') qty = 1;

		// Update product name in popup

		let title = product.find('.product__title').text();

		let productAddTemplate = $('.product_template_title').data('template');

		let productAdd = productAddTemplate.replace(/{n}/g, title);

		$('.product_template_title').text(productAdd);

		// Update product image in popup

		let image = product.data('image');

		let imageHTML = '';

		if (image) {
			let src = '';

			if (image.startsWith('http')) {
				src = image;
			} else {
				src = `/public/products/${image}`;
			}

			imageHTML = `<picture>

										<source srcset="${src}" type="image/webp">

										<img src="${src}" alt="${title}">

									</picture>`;
		}

		$('.product_template_image').html(imageHTML);

		$.ajax({
			url: '/cart/add', // путь к обработчику

			type: 'POST', // метод отправки,

			dataType: 'json',

			data: {
				product_id: id,

				quantity: qty,
			},

			success: function (data) {
				console.log('data: ', data);

				if (data.status == 'ok') {
					$('.total_cart_price').html(data.total_price);

					header_cart();

					if (type === 'checkbox') location.reload();
				}
			},

			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Remove from cart
	$('body').on('click', '.remove_from_cart', function (e) {
		e.preventDefault();

		const _self = $(this);

		let type = _self.data('type');

		let reload = _self.data('reload');

		let row_id = _self.data('row_id');

		// Confirm

		let confirmation = _self.data('confirmation');

		let confirmed = confirm(confirmation);

		if (!confirmed) return;

		$.ajax({
			url: '/cart/delete', // путь к обработчику

			type: 'POST', // метод отправки,

			dataType: 'json',

			data: { row_id: row_id },

			success: function (data) {
				console.log('data: ', data);

				if (data.status == 'ok') {
					if (reload) {
						location.reload();
					} else {
						$('.total_cart_price').html(data.total_price);

						header_cart();
					}
				}
			},

			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Remove all from cart
	$('body').on('click', '.remove_all_from_cart', function (e) {
		e.preventDefault();

		const _self = $(this);

		let reload = _self.data('reload');

		// Confirm

		let confirmation = _self.data('confirmation');

		let confirmed = confirm(confirmation);

		if (!confirmed) return;

		$.ajax({
			url: '/cart/delete_all', // путь к обработчику

			type: 'GET', // метод отправки,

			dataType: 'json',

			success: function (data) {
				console.log('data: ', data);

				if (data.status == 'ok') {
					if (reload) {
						location.reload();
					} else {
						$('.total_cart_price').html(data.total_price);

						header_cart();
					}
				}
			},

			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Update quantity
	$('body').on('click', '.update_item_qty', function (e) {
		e.preventDefault();

		const _self = $(this);

		let product = _self.closest('.product__box');

		let input = product.find('.product__qty');

		let row_id = input.data('row_id');

		let qty = input.val();

		let free = $('.delivery__total').data('free');

		let currency = $('.delivery__total').data('currency');

		$.ajax({
			url: '/cart/update', // путь к обработчику

			type: 'POST', // метод отправки,

			dataType: 'json',

			data: { row_id: row_id, quantity: qty },

			success: function (data) {
				// console.log('data: ', data);

				if (data.status == 'ok') {
					$('.total_cart_price').html(data.total_price);

					if (!product.hasClass('header_cart')) {
						header_cart();

						product.find('.item__total').html(data.item_total);

						$('.products__total').html(data.products_total);

						$('.discount__total').html(data.discount_price);

						$('.cart__total').html(data.cart_total);

						if (data.price_levels_totals) {
							Object.entries(data.price_levels_totals).forEach(
								([label, total]) => {
									$(`.cart-level-total[data-level-label="${label}"]`).text(
										total,
									);
								},
							);
						}

						if (data.progress >= 100) {
							$('.delivery__total').html(free);

							$('.delivery__progress').css('width', data.progress + '%');
						} else {
							$('.delivery__total').html(data.delivery_price + ' ' + currency);

							$('.delivery__progress').css('width', data.progress + '%');
						}
					} else {
						$('.header_cart_total').html(data.total_price);
					}
				}
			},

			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Order
	if ($('.takeout__tabs').length) {
		const courierTab = document.querySelector('li[data-type="courier"]');

		const pickupTab = document.querySelector('li[data-type="pickup"]');

		const deliveryTotal = document.querySelector('.delivery__total');

		const deliveryTotalFree = document.querySelector('.delivery__total--free');

		const cartTotal = document.querySelector('.sidebar__cart__total');

		const cartTotalFree = document.querySelector('.sidebar__cart__total--free');

		courierTab.addEventListener('click', function () {
			deliveryTotal.style.display = 'block';

			deliveryTotalFree.style.display = 'none';

			cartTotal.style.display = 'flex';

			cartTotalFree.style.display = 'none';
		});

		pickupTab.addEventListener('click', function () {
			deliveryTotal.style.display = 'none';

			deliveryTotalFree.style.display = 'block';

			cartTotal.style.display = 'none';

			cartTotalFree.style.display = 'flex';
		});
	}
	$('.express_delivery_checkbox').on('change', function () {
		var deliveryTotal = $('.delivery__total');

		var basePrice = parseFloat(deliveryTotal.data('price'));

		var expressPrice = parseFloat(deliveryTotal.data('express-price'));

		var currency = deliveryTotal.data('currency');

		var free = deliveryTotal.data('free');

		var cartTotal = $('.cart__total__container');

		var cartPrice = parseFloat(cartTotal.data('total'));

		if ($(this).is(':checked')) {
			// Add express delivery price

			$('.delivery__price').text((basePrice + expressPrice).toFixed(2));

			$('.delivery__free').text(expressPrice.toFixed(2) + ' ' + currency);

			$('.sidebar__cart__total .cart__total').text(
				(cartPrice + basePrice + expressPrice).toFixed(2),
			);

			$('.sidebar__cart__total--free .cart__total').text(
				(cartPrice + expressPrice).toFixed(2),
			);
		} else {
			// Set back to base delivery price

			$('.delivery__price').text(basePrice.toFixed(2));

			$('.delivery__free').text(free);

			$('.sidebar__cart__total .cart__total').text(
				(cartPrice + basePrice).toFixed(2),
			);

			$('.sidebar__cart__total--free .cart__total').text(cartPrice.toFixed(2));
		}
	});
	$('.one__click, .buy__credit').on('click', function (e) {
		const _self = $(this);
		let product = _self.closest('.product__box');
		let id = product.data('id');
		let currency = product.data('currency');
		let type = _self.data('type');

		$.ajax({
			url: '/get_product', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				id: id,
				lang: lang,
			},
			success: function (data) {
				console.log('data: ', data);
				if (data.status == 'ok') {
					var price_html = '';
					if (
						data.old_price &&
						parseFloat(data.old_price) > parseFloat(data.price)
					) {
						price_html = `<span class="_now">${data.price} ${currency}</span>
													<span class="_old">${data.old_price} ${currency}</span>`;
					} else {
						price_hTML = `<span>${data.price} ${currency}</span>`;
					}
					if (type === 'one_click') {
						$('.one__click-product_id').val(data.id);
						$('.one__click-image picture source').attr('srcset', data.image);
						$('.one__click-image picture img').attr('src', data.image);
						$('.one__click-title').html(data.title);
						$('.one__click-text').html(data.text);
						$('.one__click-barcode').html(data.barcode);
						$('.one__click-price').html(price_html);
					} else if (type === 'buy_credit') {
						let monthly = _self.data('monthly');
						let payments = _self.data('payments');
						$('.buy__credit-product_id').val(data.id);
						$('.buy__credit-image picture source').attr('srcset', data.image);
						$('.buy__credit-image picture img').attr('src', data.image);
						$('.buy__credit-title').html(data.title);
						$('.buy__credit-text').html(data.text);
						$('.buy__credit-barcode').html(data.barcode);
						$('.buy__credit-price').html(price_html);
						var credit_offers_html = '';
						data.credit_offers.forEach(function (offer) {
							var offer_percent = offer.percent
								? `<span class="offer-credit__percent">${offer.percent}</span>`
								: '';
							credit_offers_html += `<label class="offer-credit__item">
																			<input type="radio" name="buy_credit[months]" value="${offer.months}" data-value="${offer.value}" data-percent="${offer.percent || '0%'}" class="offer-credit__input buy__credit-offer_radio">
																			<div class="offer-credit__body">
																				<span class="offer-credit__month">${offer.months}</span>
																				<div class="offer-credit__info">
																					<span class="offer-credit__text">${payments}</span>
																					<span class="offer-credit__value">${offer.value} ${currency}</span>
																				</div>
																				${offer_percent}
																			</div>
																		</label>`;
						});
						$('.buy__credit-offers').html(credit_offers_html);
						$(document).on('change', '.buy__credit-offer_radio', function () {
							var selected_value = $(this).data('value');
							var selected_percent = $(this).data('percent');
							$('.buy__credit-interest').val(selected_percent);
							$('.buy__credit-monthly').html(
								`${selected_value} ${currency} ${monthly}`,
							);
						});
					}
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Currency
	function changeCurrency(currency_id) {
		$.ajax({
			url: '/currency_change', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				currency_id: currency_id,
			},
			success: function (data) {
				console.log('data: ', data);
				if (data.status == 'ok') {
					const url = new URL(window.location.href);
					url.searchParams.delete('min_price');
					url.searchParams.delete('max_price');
					location.href = url.toString();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
	$('.currency-change__item').on('click', function () {
		changeCurrency($(this).data('value'));
	});

	//! Select
	function handleSelectOption(selectClass, callback) {
		$(selectClass)
			.find('.select__options')

			.on('click', '.select__option', function () {
				var $clicked = $(this);

				var value = $clicked.data('value');

				var $select = $(this).closest(selectClass).find('select');

				var option = $select.find('option[value="' + value + '"]')[0];

				if (typeof callback === 'function') {
					callback(option);
				}
			});
	}
	handleSelectOption('.currency__change', function (option) {
		changeCurrency(option.value);
	});
	handleSelectOption('.language__change', function (option) {
		window.location.href = option.value;
	});
	handleSelectOption('.city__change', function (option) {
		$.ajax({
			url: '/city_change', // путь к обработчику

			type: 'POST', // метод отправки,

			dataType: 'json',

			data: {
				city_id: option.value,
			},

			success: function (data) {
				console.log('data: ', data);

				if (data.status == 'ok') {
					// location.reload();
				}
			},

			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
});